import { mainPath } from "../../lib/mainPath";
import { requestsTemplates } from "../../lib/requestsTemplates";

export const changePassword = (passwords) =>requestsTemplates.post(mainPath, "/user/changePassword",passwords);